import React, {Component} from 'react'
import { connect } from 'react-redux'

// Actions
import { getCompanySchemaAssociations } from '../../../actions/esg'

// import components
import Col from '../../../shared/elements/col'
import Header from '../../../shared/components/Header'
import LeftMenuContent from '../../../shared/components/Menus/LeftMenu/Content'

// Elements
import DropDown from '../../../shared/elements/dropDown'
import Panel from '../../../shared/elements/panel'
import Row from '../../../shared/elements/row'
import SideMenu from '../../../shared/elements/sideMenu'
import SideMenuItem from '../../../shared/elements/sideMenuItem'

// Utils
import { translation } from '../../../utils/helpers'
import Scopes from './Components/scopes'

import './index.scss'
import ManualReporting from './Components/manualReporting'

class ESGCompany extends Component {
  constructor (props) {
    super(props)
    this.defaultAssociation = { Name: '', SchemaId: 0, Years: [], SelectedYear: 0 }
    this.state = {
      associations: [],
      slecectedAssociation: this.defaultAssociation
    }
  }

  componentDidMount () {
    this.props.getCompanySchemaAssociations().then((res) => {
      this.setState({
        associations: res.data,
        slecectedAssociation: this.defaultAssociation // res.data.at(-1)
      })
    }, () => {
      window.toastr.error(translation(960), translation('216'))
    })
  }

  renderSchemaSelector () {
    let { SelectedYear, Years, Name } = this.state.slecectedAssociation

    const onChange = ({ target: { value } }) => this.setState({ slecectedAssociation: { ...this.state.slecectedAssociation, SelectedYear: value } })
    return (
      <Panel title={Name}>
        <DropDown value={SelectedYear} onChange={onChange} labelText={translation(18407)}>
          <option key='default' value={0}>{translation(18427)}</option>
          {Years.map((obj, k) => {
            return <option key={k} value={obj}>{obj}</option>
          })}
        </DropDown>
      </Panel>
    )
  }

  render () {
    let { SchemaId, SelectedYear } = this.state.slecectedAssociation

    const renderList = () => {
      return this.state.associations.map(s => {
        return (
          <SideMenuItem
            label={s.Name}
            onClick={() => this.setState({ slecectedAssociation: s })}
            selected={s.SchemaId === SchemaId}
            key={s.SchemaId}
          />
        )
      })
    }

    return (
      <div className='schema_screen'>
        <Header />
        <SideMenu showFilter hideInactiveCheck>
          {renderList()}
        </SideMenu>
        <LeftMenuContent className='schemas__screen--inner'>
          {(SchemaId > 0) && (
            <Row>
              <Col>
                {this.renderSchemaSelector()}
              </Col>
            </Row>
          )}
          {(SchemaId > 0 && SelectedYear > 0) && <ManualReporting schemaId={SchemaId} year={SelectedYear} />}
          {(SchemaId > 0 && SelectedYear > 0) && <Scopes schemaId={SchemaId} year={SelectedYear} />}
        </LeftMenuContent>
      </div>
    )
  }
}

export default connect(null, {
  getCompanySchemaAssociations
})(ESGCompany)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Company/index.js